export const ERROR_MESSAGES = {
  SIGNUP_FAILED: "Signup failed, Please try again after some time",
  LOGIN_FAILED: "Login failed, Please try again after some time",
  LOGIN_USER_ACCOUNT_NOT_EXIST: "User account does not exist, Please sign up.",
  SSO_LOGIN_FAILED: "SSO login failed, Please try again after some time",
  SSO_ACCOUNT_NOT_CONFIRMED:
    "You signed up with email but have not verified it yet. Confirm your email first, then sign in with Google or Facebook.",
  EMAIL_ALREADY_REGISTERED_VIA_SSO:
    "This email is already registered with a social account. Please sign in using Google or Facebook.",
  ERROR_RESET_PASSWORD: "Error resetting password, Please try again",
  FORGOT_PASSWORD_NO_ACCOUNT_FOR_EMAIL:
    "We couldn't find an account with that email. Check the spelling or try signing up.",
  ERROR_VERIFY_EMAIL: "Error verifying email, Please try again",
  ERROR_RESEND_CONFIRMATION_CODE:
    "Error resending confirmation code, Please try again",
  ERROR_CHANGE_PASSWORD: "Error changing password, Please try again",
  INVALID_OTP: "Please enter a valid OTP",
  FAILED_TO_RESEND_OTP: "Failed to resend OTP",
  EMAIL_VERIFICATION_FAILED: "Email verification failed",
  AUTO_LOGIN_AFTER_VERIFY_FAILED:
    "Your email was verified, but we could not sign you in automatically. Please sign in with your password.",
  EMAIL_REQUIRED_FOR_VERIFICATION_CODE:
    "We need your email on this page to send a verification code. Go back to sign in and try again.",
  RESET_PASSWORD_VALIDATION_FAILED:
    "Please provide both email and new password to reset your password",
  FAILED_TO_RESET_PASSWORD: "Failed to reset password, Please try again",
  AN_UNEXPECTED_ERROR_OCCURRED: "An unexpected error occurred",
  NOT_LOGGED_IN: "Not logged in",
  USER_TOKEN_MISSING: "User is not authenticated. Please log in again.",
  ACCESS_TOKEN_SUB_MISSING:
    "Access token is missing a valid user identity. Please log in again.",
  FAILED_TO_FETCH_USER_DETAILS:
    "Failed to fetch user details. Please try again after some time",
  NO_AUTHORIZATION_CODE_RECEIVED: "No authorization code received",
  FAILED_TO_DEACTIVATE_PROFILE: "Failed to deactivate profile",
  PROFILE_CHANGES_SAVED_FAILED: "Failed to save profile changes",
  FAILED_TO_UPDATE_USER_STATUS: "Failed to update user status",
  FAILED_TO_FETCH_USER_FAVOURITES: "Failed to fetch user favourites",
  FAILED_TO_DELETE_USER_FAVOURITES: "Failed to delete user favourites",
  FAILED_TO_DELETE_USER: "Failed to delete account. Please try again.",
  INVALID_IMAGE_FILE: "Please select a valid image file (JPEG, JPG, PNG, GIF, WEBP, BMP)",
  IMAGE_FILE_TOO_LARGE:
    "One or more images exceed the 10 MB limit. Please upload smaller images.",
  PROFILE_IMAGE_SVG_NOT_ALLOWED:
    "SVG files cannot be used for profile photos. Please use JPEG, PNG, GIF, WEBP, or BMP.",
  ERROR_UPDATING_PROFILE_IMAGE: "Error updating profile image",
  ERROR_FETCHING_PROFILE_DATA: "Error fetching profile data",
  FAILED_TO_DELETE_PROFILE_IMAGE: "Failed to delete profile image. Please try again later.",
  NO_LISTINGS_FOUND: "No goodies found",
  NO_LISTINGS_ADDED_YET: "No goodies added yet. Be the first to add a goodie.",
  NO_LISTINGS_FOUND_FOR_USER: "No goodies found for this user",
  NO_LISTINGS_ADDED_FOR_USER: "No goodies added. Add your first goodie now.",
  ALL_LISTINGS_SEEN: "You have seen it all",
  FAILED_TO_CREATE_LISTING: "Failed to add goodie. Please try again.",
  FAILED_TO_UPDATE_LISTING: "Failed to update goodie. Please try again.",
  PLEASE_UPLOAD_AT_LEAST_ONE_IMAGE: "Please upload at least one image",
  USER_ID_REQUIRED_FOR_FETCHING_USER_ITEMS: "User ID required for fetching user goodies",
  NO_PRODUCT_ID_PROVIDED_TO_FETCH_PRODUCT_ITEM_DATA: "No productId provided to fetch product goodie data",
  FAILED_TO_FETCH_ITEM_DETAILS: "Failed to fetch goodie details",
  INVALID_LOCATION_DATA: "Invalid location data",
  LOCATION_DATA_REQUIRED: "Location data required",
  FAILED_TO_COPY_LINK_TO_CLIPBOARD: "Failed to copy link to clipboard",
  SOMETHING_WENT_WRONG: "Something went wrong, Please try again after some time",
  REPORT_FAILED_ITEM: "Something went wrong while reporting goodie. Please try again after some time",
  REPORT_FAILED_USER: "Something went wrong while reporting user. Please try again after some time",
  FAILED_TO_UPDATE_REPORT_STATUS: "Failed to update report status",
  FAILED_TO_FETCH_ITEMS_CATEGORIES: "Failed to fetch goodie categories",
  LOCATION_NOT_FOUND: "Location not found. Please try a different search term",
  CATEGORY_REQUIRED: "Category is required",
  CONDITION_REQUIRED: "Condition is required",
  ITEM_ID_REQUIRED_FOR_REPORTING_ITEM: "Goodie ID is required for reporting a goodie",
  USER_ID_REQUIRED_FOR_REPORTING_USER: "User ID is required for reporting a user",
  FAILED_TO_CREATE_CONDITION: "Failed to create condition",
  FAILED_TO_UPDATE_CONDITION: "Failed to update condition",
  FAILED_TO_DELETE_CONDITION: "Failed to delete condition",
  FAILED_TO_CREATE_REVIEW_CATEGORY: "Failed to create review category",
  FAILED_TO_UPDATE_REVIEW_CATEGORY: "Failed to update review category",
  FAILED_TO_DELETE_REVIEW_CATEGORY: "Failed to delete review category",
  FAILED_TO_FETCH_STATS: "Failed to fetch stats",
  FAILED_TO_SEND_BROADCAST_MESSAGE: "Failed to send broadcast message",
  FAILED_TO_SEND_ALERT_TO_USER: "Failed to send alert to user",
  FAILED_TO_UNLIST_ITEM: "Failed to unlist goodie",
  FAILED_TO_ACTIVATE_USER: "Failed to activate user",
  FAILED_TO_DEACTIVATE_USER: "Failed to deactivate user",
  FAILED_TO_UPDATE_ITEM_STATUS: "Failed to update goodie status",
  ACCOUNT_SUSPENDED: "Your account is currently suspended by the admin for violating our policies",
  DEVICE_REGISTRATION_FAILED: "Device registration failed",
  DEVICE_REGISTRATION_BLOCKED:
    "Device registration is paused after several failed attempts. Try again later or contact support.",
  DEVICE_TOKEN_UNAVAILABLE:
    "Notification permission not set for browser or not supported",
  DEVICE_REMOVAL_FAILED: "Device removal failed",
  NOTIFICATION_SEND_FAILED:
    "Failed to send notification. Please try again after some time",
  FETCH_USER_NOTIFICATIONS_FAILED:
    "Failed to fetch notifications. Please try again after some time",
  READ_NOTIFICATION_FAILED:
    "Failed to mark notification as read. Please try again after some time",
  DELETE_NOTIFICATION_FAILED:
    "Failed to delete notification. Please try again after some time",
  BROADCAST_NOTIFICATION_FAILED:
    "Failed to broadcast notification. Please try again after some time",
  REVIEW_STATUS_FAILED: "Failed to update review status",
  REPORTED_USER_FETCH_FAILED: "Failed to fetch reported users",
  CHAT_AUTH_FAILED: "Failed to authenticate chat. Please try again after some time",
  CHAT_AUTH_INVALID_RESPONSE: "Invalid chat authentication response",
  CHAT_AUTH_NO_ACCESS_TOKEN: "No access token",
  FAILED_TO_FETCH_CHATS: "Failed to fetch chats. Please try again after some time",
  AT_LEAST_ONE_PARTICIPANT_REQUIRED: "At least one participant is required",
  FAILED_TO_CREATE_CHAT_ROOM: "Failed to create chat room",
  FAILED_TO_CREATE_CHAT: "Failed to create chat",
  FAILED_TO_SEND_MESSAGE: "Failed to send message",
  CANNOT_SEND_MESSAGE_REPORTED_USER:
    "Unable to send messages to this user because you have previously reported them.",
  FAILED_TO_ADD_REACTION: "Could not add reaction. Please try again.",
  NO_CHATS_FOUND: "You do not have any conversations yet.",
  CHAT_NOT_FOUND: "This conversation could not be loaded. It may not exist or may not be in your inbox yet.",
  FAILED_TO_FETCH_NOTIFICATION: "Failed to fetch notification. Please try again after some time",
  ADMIN_INVITE_FAILED: "Could not invite admin. Please try again.",
  ADMIN_SET_PASSWORD_FAILED: "Could not set password. Your session may have expired — try logging in again.",
  ADMIN_INVITE_FORBIDDEN: "Only administrators can invite other admins.",
  LOCATION: {
    GEOLOCATION_NOT_SUPPORTED: "Geolocation is not supported by this browser.",
    LOCATION_ACCESS_DENIED: "Location access denied.",
    LOCATION_INFORMATION_UNAVAILABLE: "Location information is unavailable.",
    LOCATION_REQUEST_TIMED_OUT: "Location request timed out.",
    COULD_NOT_FETCH_LOCATION: "Could not fetch your location. Try again or pick on the map.",
  },
  AUTH: {
    FAILED_TO_SEND_RESET_TOKEN: "Failed to send reset token",
    SOMETHING_WRONG_SENDING_RESET_TOKEN: "Something went wrong while sending reset token",
  },
  SHARE: {
    FAILED_TO_SHARE_TO_INSTAGRAM: "Failed to share to Instagram",
  },
  MAP: {
    SEARCH_FAILED: "Search failed, Please try again",
    LOCATION_NOT_FOUND: "Location not found, Please try a different search term",
    REVERSE_GEOCODING_FAILED: "Reverse geocoding failed, Please try again",
  },
  ONBOARDING: {
    FAILED_TO_COMPLETE_ONBOARDING: "Failed to verify your age. Please try again.",
    AT_LEAST_16_YEAR: "At least 16 years old required",
    ACCOUNT_REMOVED: "Account has been removed",
  },
  FAVOURITES: {
    FAILED_TO_ADD: "Failed to add favourite",
    FAILED_TO_REMOVE: "Failed to remove favourite",
    FAILED_TO_UPDATE: "Failed to update favourite status",
  }
};

export const PAGE_TITLE_TEXT = {
  AUTH_VERIFICATION: {
    ACC_NOT_VERIFIED:  "Account not verified",
    VERIFY_YOUR_EMAIL: "Verify your email",
  }
}

export const CONFIRM_MAIL_FLOW = {
  FORGOT_PASSWORD: "forgot-password",
  RESET_FORGOT_PASSWORD: "reset-forgot-password",
  CONFIRM_MAIL: "confirm-mail",
  CHANGE_PASSWORD: "change-password",
} as const;

export const PAGE_INFO_MESSAGES = {
  BUTTON_TEXT: {
    YES_DELETE: "Yes, Delete",
    CANCEL: "Cancel",
    SAVE: "Save",
  },
  AUTH_VERIFICATION: {
    USER_NOT_CONFIRMED: "user not confirmed",
    ACCOUNT_NOT_VERIFIED_FROM_LOGIN:
      "This account is not verified yet. Enter the verification code from your email, or use Resend OTP to get a new code.",
    REQUEST_VERIFICATION_CODE_FIRST:
      "This account is not verified yet. Send a verification code to your email, then enter it below.",
    SSO_CONFIRM_EMAIL_FIRST:
      "Your email account is not verified yet. Enter the email you used to sign up, send a verification code, then enter it below before using Google or Facebook.",
    SIGN_IN_AFTER_VERIFY_SESSION_EXPIRED:
      "Please sign in with the password you created when you signed up.",
  },
  PROFILE: {
    NEW_LISTING_DEFAULT_UNLISTED:
    "When you create this goodie, it is saved as unlisted. It will not appear in search or public browsing until you open it from your profile and choose Mark as Up for Grabs.",
    TOTAL_GOODIES: "Total goodies",
    GRAB_IN_PROGRESS: "Grab in Progress",
    GIVEN: "Given",
  },
  FAVOURITES: {
    NO_FAVOURITES: "You don't have any favourites yet. Add some to get started.",
    REMOVE_FROM_FAVOURITES: "Remove from favourites",
    ADD_TO_FAVOURITES: "Add to favourites",
  },
  DASHBOARD: {
    INTERESTING_FINDINGS_NEAR_YOU: "Goodies Near You",
    MY_LISTINGS: "My Goodies",
    LISTINGS: "Goodies",
    ADD_LISTING: "Add Goodie",
  },
  NOTIFICATION_CENTER: {
    REDIRECTING_TO_CONVERSATION: "Redirecting to conversation…",
    LOADING_NOTIFICATION: "Loading notification…",
    HAVING_ANY_ISSUES: "Having any issues?",
    ENABLE_NOTIFICATIONS: "Enable notifications to receive instant alerts.",
    ENABLING_NOTIFICATIONS: "Enabling...",
    ENABLE_NOTIFICATIONS_BUTTON: "Enable Notifications",
  },
  AGE_VERIFICATION_MODAL: {
    TITLE: "Verify your age",
    DESCRIPTION: "Please enter your date of birth to continue using your account.",
    DOB_LABEL: "Date of Birth",
    CANCEL: "Cancel",
  },
  CATEGORY_MANAGEMENT: {
    ACTIVE_GOODIES: "Active goodies",
    DELETE_CATEGORY_TITLE: "Are you sure you want to delete this category?",
    DELETE_CONDITION_TITLE: "Are you sure you want to delete this item?",
  },
  REPORT_DISCLAIMER: {
    SEE_ANY_PROBLEM: "See any problem with this goodie? ",
    REPORT_HERE: "Report here",
  },
  ITEM_LISTING: {
    NEW_GOODIE_TITLE: "New Goodies",
  },
  APP_TAGLINE: "Good things are meant to be shared.",
};

export const SUCCESS_MESSAGES = {
  SUCCESSFULLY_LOGGED_IN: "Successfully Logged In",
  PASSWORD_RESET_SUCCESSFUL: "Password reset successful!",
  SSO_LOGIN_SUCCESS: "SSO login successful!",
  EMAIL_VERIFIED_SUCCESS:
    "Email verified successfully! Please login to continue",
  EMAIL_VERIFIED_AND_LOGGED_IN:
    "Email verified successfully! Signing you in...",
  OTP_RESENT_SUCCESS: "OTP resent successfully to your email",
  PASSWORD_CHANGED_SUCCESSFULLY: "Password changed successfully!",
  PROFILE_CHANGES_SAVED_SUCCESSFULLY: "Profile changes saved successfully!",
  FAVOURITE_ADDED_SUCCESSFULLY: "Favourite added successfully",
  FAVOURITE_REMOVED_SUCCESSFULLY: "Favourite removed successfully",
  PROFILE_IMAGE_DELETED_SUCCESSFULLY: "Profile image deleted successfully",
  PROFILE_ACTIVATED_SUCCESSFULLY: "Profile activated successfully",
  ONBOARDING_COMPLETED_SUCCESSFULLY: "Age verified successfully",
  USER_DELETED_SUCCESSFULLY: "Your account has been deleted successfully",
  LISTING_CREATED_SUCCESSFULLY: "Goodie created successfully!",
  LISTING_UPDATED_SUCCESSFULLY: "Goodie updated successfully!",
  LINK_COPIED_TO_CLIPBOARD: "Link copied to clipboard!",
  REPORT_SUBMITTED_SUCCESSFULLY: "Reported successfully, we will review it and take appropriate action",
  REPORTED_ITEMS_FETCHED_SUCCESSFULLY: "Reported goodies fetched successfully",
  REVIEW_DETAILS_FETCHED_SUCCESSFULLY: "Review fetched successfully",
  REVIEWS_LIST_FETCHED_SUCCESSFULLY: "Reviews fetched successfully",
  FETCH_ALL_CATEGORIES_SUCCESS: "All categories fetched successfully",
  CONDITION_CREATED_SUCCESSFULLY: "Condition created successfully",
  CONDITION_UPDATED_SUCCESSFULLY: "Condition updated successfully",
  CONDITION_DELETED_SUCCESSFULLY: "Condition deleted successfully",
  REVIEW_CATEGORY_CREATED_SUCCESSFULLY: "Review category created successfully",
  REVIEW_CATEGORY_UPDATED_SUCCESSFULLY: "Review category updated successfully",
  REVIEW_CATEGORY_DELETED_SUCCESSFULLY: "Review category deleted successfully",
  REPORT_STATUS_UPDATED_SUCCESSFULLY: "Report status updated successfully",
  STATS_LOADED_SUCCESSFULLY: "Stats loaded successfully",
  BROADCAST_MESSAGE_SENT_SUCCESSFULLY: "Broadcast message sent successfully",
  ALERT_SENT_TO_USER_SUCCESSFULLY: "Alert sent to user successfully",
  DEVICE_REGISTRATION_SUCCESS: "Device registration successful",
  DEVICE_REMOVAL_SUCCESS: "Device removal success",
  NOTIFICATION_SENT_SUCCESS: "Notification sent successfully",
  BROADCAST_NOTIFICATION_SUCCESS: "Broadcast notification sent successfully",
  ITEM_UNLISTED_SUCCESSFULLY: "Goodie unlisted successfully",
  ITEM_STATUS_UPDATED_SUCCESSFULLY: "Goodie status updated successfully",
  USER_ACTIVATED_SUCCESSFULLY: "User has been activated",
  USER_DEACTIVATED_SUCCESSFULLY: "User has been deactivated",
  USER_MARKED_AS_COMPLETE: "User marked as complete",
  REVIEW_STATUS_UPDATED: "Review status updated successfully",
  NEW_NOTIFICATION: "New Notification",
  YOU_HAVE_A_NEW_NOTIFICATION: "You have a new notification.",
  ADMIN_INVITE_SENT: "Invitation sent. The new admin will receive login details by email.",
  ADMIN_PASSWORD_SET_SUCCESS: "Password set successfully. Welcome!",
};
